import { FormOfPaymentOptions } from 'app/calcs/pensions'
import { AllFormsOfPayment, IFormOfPaymentOption } from 'app/calcs/pensions/interfaces'
import { RadioGroup } from 'app/components/form/RadioGroup'
import { makeDebug } from 'app/utils'
import * as _ from 'lodash'
import * as React from 'react'

const debug = makeDebug(true)

interface IFormOfPaymentProps {
  name: string
  defaultValue: number
  onChange?: (fopo: number) => void
  options?: AllFormsOfPayment[]
}

interface IFormOfPaymentState {
  selectedValue: number
}

class FormOfPayment extends React.Component<IFormOfPaymentProps, IFormOfPaymentState> {

  componentWillMount() {
    const selectedValue = this.props.defaultValue

    this.setState({ selectedValue })
  }

  toNumber(num: string) {
    if (!num) {
      return null
    }

    return Number(num).valueOf()
  }

  updateSelectedValue(value: string) {
    const selectedValue = this.toNumber(value)
    this.setState({ selectedValue })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(selectedValue)
    }
  }

  render() {
    let fop: IFormOfPaymentOption[] = FormOfPaymentOptions
    if (this.props.options) {
      fop = _.filter(FormOfPaymentOptions, (q) => _.includes(this.props.options, q.value))
    }
    
    return (
      <div className="formOfPayment">
        <div className="Question">What form of payment will you select?</div>
        <RadioGroup name={this.props.name}
          selectedValue={this.state.selectedValue}
          onChange={(value) => this.updateSelectedValue(value)}
          options={fop} />
      </div>
    )
  }
}

export {
  FormOfPayment
}



// WEBPACK FOOTER //
// ./src/app/components/questions/FormOfPayment/index.tsx